import Heading from 'components/atoms/Heading/Heading';
import MoreSurveysBanner from 'components/molecules/MoreSurveysBanner/MoreSurveysBanner';
import NoSurveys from 'components/molecules/NoSurveys/NoSurveys';
import { DashboardToolbarOptions } from 'components/organisms/DashboardToolbar/DashboardToolbar';
import PushNotificationsModal from 'components/organisms/PushNotifications/PushNotificationsModal';
import SurveyList from 'components/organisms/SurveyList/SurveyList';
import TermsAndConditionsConsent from 'components/templates/TermsAndConditionsConsent/TermsAndConditionsConsent';
import { useCountdownTimer } from 'hooks/useCountdownTimer';
import useQueryStringParams from 'hooks/useQueryStringParams';
import useShowAdmin from 'hooks/useShowAdmin';
import React, { useState } from 'react';
import classes from './Dashboard.module.scss';

import { useDashboardQuery } from './useDashboardQuery';

export interface Props {}

const Dashboard: React.FC<Props> = () => {
  const [surveyFilter, setSurveyFilter] = useState<DashboardToolbarOptions>(
    DashboardToolbarOptions.AllSurveys,
  );
  const showAdminSurveys = useShowAdmin();
  const { showPushNotificationModal } = useQueryStringParams();
  const [isPushNotificationModalOpen, setIsPushNotificationModalOpen] = useState(true);

  const data = useDashboardQuery({
    input: {
      PIISurveys: true,
      webcamSurveys: true,
      trackingParams: showAdminSurveys ? [{ key: 'am', value: 'true' }] : [],
    },
  });

  const shouldShowPushNotificationModal =
    showPushNotificationModal === 'true' &&
    isPushNotificationModalOpen &&
    ((typeof Notification !== 'undefined' &&
      Notification.permission !== 'granted' &&
      Notification.permission !== 'denied') ||
      !data.notificationSubscriptions.surveyInviteContactChannels?.includes('pushNotification'));

  const { clearCountdown } = useCountdownTimer('secondFactorCountdown');

  React.useEffect(() => {
    clearCountdown();
  }, [clearCountdown]);

  return (
    <TermsAndConditionsConsent consentSettingsRef={data.consentSettings}>
      {data.surveys?.pageInfo.totalCount ? (
        <div className={classes.root}>
          <section>
            <div className={classes.bannerContainer}>
              <MoreSurveysBanner profileUrlRef={data} className={classes.moreSurveysBanner} />
            </div>
            <Heading level={2}>Today&apos;s Surveys</Heading>
            <SurveyList
              onFiltersChanged={setSurveyFilter}
              surveyFilter={surveyFilter}
              surveysRef={data}
              disabled={Boolean(data.signupSurveyUrl)}
            />
            {shouldShowPushNotificationModal && (
              <PushNotificationsModal
                userName={data.userData?.firstName ?? ''}
                onCancel={() => setIsPushNotificationModalOpen(false)}
              />
            )}
          </section>
        </div>
      ) : (
        <NoSurveys noSurveysRef={data} />
      )}
    </TermsAndConditionsConsent>
  );
};

export default Dashboard;
